import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import './videos-tab.scss';
export default function VideoTab({ videos }) {
    return (React.createElement("div", { className: "videos-tab" }, videos.map(({ title, description, embed }) => (React.createElement("div", { className: "video-block", key: title },
        React.createElement("h2", { className: "title" }, title),
        React.createElement(RawHTML, { html: description, className: "description" }),
        React.createElement(RawHTML, { html: embed, className: "embed", embed: true }))))));
}
